

function initPane(el) {
	const companyId = el.getAttribute('data-company')
	const searchUrl = el.getAttribute('data-search-url')
	if (!companyId) return
	const response = fetch(`/api/jobs?companyId=${companyId}`)
		.then(response => response.json())
		.then(response => {
			const items = response.data
			if (items.length > 1) el.innerHTML = pane(items[0].Company, companyId, items.length - 1, searchUrl)
		})
}

function pane(companyName, companyId, count, searchUrl) {
	return `
		<div class="cta-box bg--blue margin-bottom first-last text-white hide show@medium">
		    <h3 class="heading-5">Want to see more from ${companyName.trim()}?</h3>
		    <p>${count} more ${count === 1 ? 'role' : 'roles'} available from ${companyName}</p>
		    <a href="${searchUrl}?companyId=${companyId}" class="button button--arrow arrow--left margin-top-3 text-white">View all roles</a>
		</div>
	`
}

export default input => {
	const panes = [...document.querySelectorAll('.js-company-jobs-pane')]
	panes.map(el => initPane(el))
}